import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-flat-sale-status',
  templateUrl: './flat-sale-status.component.html',
  styleUrls: ['./flat-sale-status.component.scss']
})
export class FlatSaleStatusComponent implements OnInit {
  statusSold: boolean = false;
  statusWating: boolean = false;
  statusFree: boolean = false;
  currentFlatStatus: string;
  // flatStatusClass: string;

  @Output() public flatStatusClass = new EventEmitter();
  browserLang: string;
  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
    this.browserLang = this.translate.getBrowserLang();
    this.currentFlatStatus = this.translate.instant('STATUS');
    // if(this.browserLang === 'en') {
    //   this.currentFlatStatus = 'סטטוס';
    // } else if (this.browserLang === 'he'){
    //   this.currentFlatStatus = 'סטטוס';
    // }
    setTimeout(()=>{
      this.currentFlatStatus = this.translate.instant('STATUS');
     }, 1000);
  }
  showStatus(status) {
    // building holder set class  class="building building-top col {{ flatStatusClass }}"
    // this.flatStatusClass = status;
    this.flatStatusClass.emit(status);
    switch (status) {
      case 'sold':
        this.statusFree = false;
        this.statusWating = false;
        this.statusSold = true;
        // this.currentFlatStatus = 'נמכר';
        this.currentFlatStatus = this.translate.instant('SOLD');
        break;
      case 'waiting':
        this.statusSold = false;
        this.statusFree = false;
        this.statusWating = true;
        // this.currentFlatStatus = 'בהרשמה';
        this.currentFlatStatus = this.translate.instant('IN-REGISTRATION');
        break;
      case 'free':
        this.statusSold = false;
        this.statusWating = false;
        this.statusFree = true;
        // this.currentFlatStatus = 'פנוי';
        this.currentFlatStatus = this.translate.instant('FREE');
        break;
      case 'remove-status':
        this.statusSold = false;
        this.statusFree = false;
        this.statusWating = false;
        // this.currentFlatStatus = 'סטטוס';
        this.currentFlatStatus = this.translate.instant('STATUS');
        break;
      default:
      // code block
    }

  }
}
